import React from 'react';
import { Outlet, Route, Routes, createBrowserRouter, RouterProvider } from 'react-router-dom';
import { UnAuthorizedContent, UnAuthorizedHeader } from '../components/UnAuthorizedContent/UnAuthorizedContent';
import { useIsLoggedIn, useAppStore } from '../store/appStore';
import { AppStructure } from '../Layout/Layout';
import { config } from '../config';
import App from '../App';
import { SelectThemeFirst } from '../experiments';
import { useSpec } from '../hooks/useSpec';
import { TemplateSelection } from '../pages/TemplateSelection';
import { Categories } from '../pages/Categories';
import { StoreName } from '../pages/StoreName';
import { Domain } from '../pages/Domain';
import { SitePreview } from '../pages/SitePreview';
import { Checkout } from '../pages/Checkout';
import { UpgradeComplete } from '../pages/UpgradeComplete';

const getRouterConfig = () => {
  if (config.env === `production`) {
    return { basename: config.baseUrl };
  }
  return {};
};

function Router() {
  return (
    <>
      <Routes>
        <Route index={true} element={<Categories />} />
        <Route path="template" element={<TemplateSelection />} />
        <Route path="choose-store-name" element={<StoreName />} />
        <Route path="domain" element={<Domain />} />
        <Route path="site-preview" element={<SitePreview />} />
        <Route path="checkout" element={<Checkout />} />
        <Route path="upgrade-complete" element={<UpgradeComplete />} />
      </Routes>
      <Outlet />
    </>
  );
}

const authorizedRoutes = [
  {
    path: '/',
    element: <App />, // AppLayout wraps all the routes
    children: [
      {
        index: true,
        element: <Router />, // Default route to DsBuilderWrapper
      },
      {
        path: '*',
        element: <Router />,
      },
    ],
  },
];

const unAuthorizedRoutes = [
  {
    path: '/',
    element: (
      <AppStructure>
        <UnAuthorizedHeader />
      </AppStructure>
    ),
    children: [
      {
        index: true,
        element: <UnAuthorizedContent />,
      },
    ],
  },
];

export const AppRouter = () => {
  const isUserLoggedIn = useIsLoggedIn();
  const shouldSelectThemeFirst = useSpec(SelectThemeFirst);

  if (isUserLoggedIn || config.env !== `production`) {
    const authorizedRouter = createBrowserRouter(authorizedRoutes, getRouterConfig());
    return <RouterProvider router={authorizedRouter} />;
  }

  if (shouldSelectThemeFirst) {
    unAuthorizedRoutes[0].children.push({
      // @ts-expect-error - TODO: why path is not allowed here
      path: 'template',
      element: <TemplateSelection />,
    });
  }

  useAppStore.getState().setIsLoggedIn(false);
  const unAuthorizedRouter = createBrowserRouter(unAuthorizedRoutes, getRouterConfig());
  return <RouterProvider router={unAuthorizedRouter} />;
};
